import { TypographyProps } from '@mui/material';
import { HeadlineSmallStyled } from 'v3/shared/typography/HeadlineSmall/styles';

export const HeadlineSmall: React.FC<TypographyProps> = (props) => {
  return (
    <HeadlineSmallStyled variant="h6" {...props}>
      {props.children}
    </HeadlineSmallStyled>
  );
};
